export default {
  viewBox: "0 0 24 25",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 0H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2m-6.873 11.25-4.192-4.192L12 6l6 6-6 6-1.057-1.058 4.185-4.192H6v-1.5z\"/>"
};